import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { getWhdStatement, changeImyTierParent, changeBoParent, setStatementPosition, hideOwnershipModal,
  showAccountWithholdingModal, takeQueueItem,
  hideAccountWithholdingModal,
  addForm, showAddFormModal,
  hideAddFormModal, addNewBeneficialOwner, saveCollapsedTiers,
  hidePooledRatesModal, showPooledRatesModal } from 'actions';
import { history } from 'containers/App';
import StatementTypes from 'common/Forms/StatementTypes';
import ImyChapter3Status from 'common/Forms/ImyChapter3Status';
import Chapter3Status from 'common/Customers/Chapter3Status';
import Chapter4Status from 'common/Customers/Chapter4Status';
import ValidationInspector from 'common/Validation/ValidationInspector';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';
import BeneficialOwner from 'components/WhdStatement/beneficialOwner';
import StatementStructureTab from 'components/WhdStatement/statementStructureTab';
import StatementFormsTab from 'components/WhdStatement/statementFormsTab/statementFormsTab';
import StatementUploadsTab from 'components/WhdStatement/statementUploadsTab/statementUploadsTab';
import IntermediaryDetailsPanel from 'components/WhdStatement/intermediaryDetailsPanel';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import NotFoundPage from 'components/Errors/NotFoundPage';
import ChangeOwnershipModal from 'components/Modals/ChangeOwnershipModal';
import AddFormModal from 'components/Modals/AddFormModal';
import WithholdingRatesModal from 'components/Modals/WithholdingRatesModal';
import PooledRatesModal from 'components/Modals/PooledRatesModal';
import StatementOptionsPanel from 'components/WhdStatement/statementOptionsPanel';
import StatementActionsPanel from 'components/WhdStatement/statementActionsPanel';
import ModalWrapper from 'components/Modals/ModalWrapper';
import LinkWhsAccountModal from 'components/Modals/LinkWhsAccountModal';
import Banner from 'components/Common/Banner';

class WhdStatement extends React.PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isGettingStatement: PropTypes.bool,
    isUpdatingStatement: PropTypes.bool,
    isStructureValid: PropTypes.bool,
    match: PropTypes.shape({
      params: PropTypes.shape({
        accountId: PropTypes.string.isRequired,
        versionNumber: PropTypes.string
      }).isRequired
    }).isRequired,
    beneficiaryList: PropTypes.arrayOf(PropTypes.shape({})),
    permissions: PropTypes.arrayOf(PropTypes.string),
    settings: PropTypes.shape({
      showMultiTierManager: PropTypes.bool,
      showBulkImyUpload: PropTypes.bool,
      showExportImy: PropTypes.bool,
      showWithholding: PropTypes.bool,
      selectedClient: PropTypes.shape({
        isPiiProtectionEnabled: PropTypes.bool
      })
    }),
    statement: PropTypes.shape({
      beneficialOwners: PropTypes.arrayOf(PropTypes.shape({})),
      decimalPlacePrecision: PropTypes.number,
      intermediaryName: PropTypes.string,
      accounts: PropTypes.arrayOf(PropTypes.shape({})),
      type: PropTypes.number,
      formId: PropTypes.number,
      effectiveTo: PropTypes.string,
      jointAccountElection: PropTypes.string,
      isPublishedFallback: PropTypes.bool
    }),
    structure: PropTypes.shape({
      basicDetails: PropTypes.shape({
        formId: PropTypes.number,
        accountId: PropTypes.number,
        name: PropTypes.string,
        formIsValid: PropTypes.bool,
        workflowStage: PropTypes.number,
      }),
      recipients: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    statementPosition: PropTypes.shape({}),
    isOwnershipModalShown: PropTypes.bool,
    changeOwnershipItem: PropTypes.shape(),
    isAccountWithholdingShown: PropTypes.bool.isRequired,
    isAddFormModalShown: PropTypes.bool.isRequired,
    isSavingStatement: PropTypes.bool,
    validationResult: PropTypes.shape({
      lines: PropTypes.arrayOf(PropTypes.shape({})),
      rejections: PropTypes.arrayOf(PropTypes.shape({})),
      warnings: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    tierCollapseStructure: PropTypes.shape({}),
    isPooledRatesModalShown: PropTypes.bool.isRequired,
    isDeletingRow: PropTypes.bool,
    isAddingNewBeneficalOwner: PropTypes.bool,
    topAccount: PropTypes.shape({
      isWhsLinkingActive: PropTypes.bool
    }),
    versionWindows: PropTypes.arrayOf(PropTypes.shape({}))
  };

  static defaultProps = {
    isGettingStatement: false,
    beneficiaryList: null,
    isUpdatingStatement: false,
    isStructureValid: false,
    permissions: null,
    settings: null,
    statement: null,
    structure: null,
    isOwnershipModalShown: false,
    changeOwnershipItem: null,
    isSavingStatement: false,
    statementPosition: null,
    validationResult: null,
    tierCollapseStructure: null,
    isDeletingRow: false,
    isAddingNewBeneficalOwner: false,
    topAccount: null,
    versionWindows: null
  };

  static getChapter3DescriptionByName = (name, displayNumber = true) => {
    const item = Chapter3Status.findByName(name);
    return (item && `${ item.description }${ displayNumber ? ' - ' : '' }${ displayNumber ? item.value : '' }`) || null;
  };

  static getChapter4DescriptionByName = (name, displayNumber = true) => {
    const item = Chapter4Status.findByName(name);
    return (item && `${ item.description }${ displayNumber ? ' - ' : '' }${ displayNumber ? item.value : '' }`) || null;
  };

  static getImyChapter3DescriptionByName = (name, displayNumber = true) => {
    const item = ImyChapter3Status.findByName(name);
    return (item && `${ item.description }${ displayNumber ? ' - ' : '' }${ displayNumber ? item.value : '' }`) || null;
  };

  static buildElementId = name => (name && name.replace(/[^a-zA-Z0-9-_]/g, '')) || '';

  static scrollToLastPosition = (position) => {
    window.scrollTo({
      top: position,
      behavior: 'smooth'
    });
  };

  static getIsDirectBeneficialOwner(beneficialOwner) {
    if (beneficialOwner.ownerDetails && !beneficialOwner.ownerDetails.allocationIncomeRate && beneficialOwner.recipients) {
      return false;
    }
    return true;
  }

  constructor(props) {
    super(props);
    this.state = {
      toggleState: {
        isTierExpanded: false,
      },
      activeTab: 0,
      isAllTiersExpanded: false,
      childAccountId: null,
      childOwnerGuid: null,
      childOwnerName: null,
      childParentId: null,
      childParentGuid: null,
      missingFormsCount: 0,
      invalidFormsCount: 0,
      inReviewFormsCount: 0,
      missingAllocationCount: 0,
      rejectionsCount: 0,
      warningsCount: 0,
      selectedPills: {
        missingForms: false,
        invalidForms: false,
        inReviewForms: false,
        rejections: false,
        warnings: false,
        missingAllocation: false,
      }
    };

    this.handleChangeImyParentInputChange = this.handleChangeImyParentInputChange.bind(this);
  }

  componentDidMount() {
    const {
      match: { params: { accountId } },
      statementPosition
    } = this.props;

    this.getWithholdingStatement();
    this.setExpandedTier();
    this.calculateFilterCounts();

    if (statementPosition && statementPosition[accountId]) {
      const position = statementPosition[parseInt(accountId, 10)];
      setTimeout(() => (
        WhdStatement.scrollToLastPosition(position)
      ), 2000);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      match: { params: { accountId, versionNumber } }, statement
    } = this.props;

    const {
      match: { params: { accountId: prevAccountId, versionNumber: prevVersionNumber } }, statement: prevStatement
    } = prevProps;

    if (accountId !== prevAccountId) {
      this.getWithholdingStatement();
    }

    if (statement !== prevStatement) {
      this.setExpandedTier();
      this.calculateFilterCounts();
    }

    if (versionNumber !== prevVersionNumber) {
      const showingVersion = versionNumber !== null && typeof versionNumber !== 'undefined';
      const { activeTab } = this.state;
      if (showingVersion && activeTab !== 0) {
        this.setState({ activeTab: 0 });
      }
    }
  }

  onCloseWithholdingModal() {
    const { dispatch } = this.props;
    dispatch(hideAccountWithholdingModal());
  }

  onClosePooledRatesModal() {
    const { dispatch } = this.props;
    dispatch(hidePooledRatesModal());
  }

  setExpandedTier() {
    const { match: { params: { accountId } }, statement, tierCollapseStructure } = this.props;

    if (tierCollapseStructure && tierCollapseStructure[accountId] && statement && statement.intermediaryName) {
      this.setState({ isAllTiersExpanded: tierCollapseStructure[accountId].allTiersExpanded });
      if (tierCollapseStructure[accountId][statement.intermediaryName]) {
        this.setState({ toggleState: tierCollapseStructure[accountId][statement.intermediaryName] });
      }
    }
  }

  getWithholdingStatement() {
    const {
      dispatch,
      match: { params: { accountId, versionNumber } },
      permissions
    } = this.props;

    if (accountId > 0 && AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrEditWhs, ActivityPerms.multiTierMgrViewWhs])) {
      dispatch(getWhdStatement([accountId], versionNumber));
    }
  }

  getTierRecipientCount() {
    const { structure } = this.props;
    return structure?.recipients ? structure?.recipients.filter(r => !r.recipients).length : 0;
  }

  getTierIntermediaryCount() {
    const { structure } = this.props;
    return structure?.recipients ? structure?.recipients.filter(r => r.recipients).length : 0;
  }

  getOwners = (recipient, level, structureLocator, index) => {
    const structureLocation = `${ structureLocator && '-' }${ index }`;
    const owners = [{ level, structureLocation, accountId: recipient.basicDetails.accountId, name: recipient.basicDetails.name }];

    const items = recipient.recipients
      .map((item, idx) => item.recipients && this.getOwners(item, level + 1, structureLocation, idx));

    return items.reduce((p, c) => {
      if (!c) {
        return p;
      }

      if (Array.isArray(c)) {
        return [...p, ...c];
      }

      return [...p, c];
    }, owners);
  };

  getParent = (accountId) => {
    const { structure } = this.props;

    if (!accountId || !structure || !structure.basicDetails || !structure.basicDetails.accountId) {
      return null;
    }

    if (structure.basicDetails.accountId === accountId) {
      return structure.basicDetails;
    }

    return this.findInRecipients(accountId, structure.recipients);
  };

  getStatementImyLayers = (accountId, parentAccountId) => {
    const { structure } = this.props;

    if (!structure || !structure.basicDetails) {
      return [];
    }

    const imys = this.getImyLayers(0, accountId, parentAccountId, structure);

    return imys || [];
  };

  getImyLayers = (level, accountId, parentAccountId, recipient) => {
    if (!recipient || !recipient.basicDetails || !Array.isArray(recipient.recipients)) {
      return null;
    }

    const relation = this.getImyRelation(recipient, accountId, parentAccountId);

    const imys = [{ level, accountId: recipient.basicDetails.accountId, guid: recipient.guid, name: recipient.basicDetails.name, relation }];

    const items = recipient.recipients
      .map(item => item.recipients && this.getImyLayers(level + 1, accountId, parentAccountId, item));

    return items.reduce((p, c) => {
      if (!c) {
        return p;
      }

      if (Array.isArray(c)) {
        return [...p, ...c];
      }

      return [...p, c];
    }, imys);
  };

  findInRecipients = (accountId, recipientList) => {
    if (!recipientList || !Array.isArray(recipientList) || recipientList.length === 0) {
      return null;
    }

    let recipient = recipientList && Array.isArray(recipientList) && recipientList.find(x => x.basicDetails && x.basicDetails.accountId === accountId);
    if (recipient) {
      return recipient.basicDetails;
    }

    recipient = recipientList.find(x => x.recipients && this.findInRecipients(accountId, x.recipients) !== null);

    return null;
  };

  // eslint-disable-next-line class-methods-use-this
  getImyRelation = (imyRecipient, accountId, parentAccountId) => {
    const { childParentGuid, isOwnerParentChange } = this.state;

    const parentByGuid = isOwnerParentChange && childParentGuid && imyRecipient && imyRecipient.guid === childParentGuid;
    const parentByRoot = isOwnerParentChange
      && !childParentGuid
      && parentAccountId
      && imyRecipient
      && imyRecipient.basicDetails
      && imyRecipient.basicDetails.accountId === parentAccountId
      && !imyRecipient.guid;
    const parentByAccount = !isOwnerParentChange && parentAccountId && imyRecipient && imyRecipient.basicDetails.accountId === parentAccountId;
    const parentAccount = (parentByGuid || parentByAccount || parentByRoot) ? 'parent' : null;

    let selfAccount = null;
    if (!isOwnerParentChange && accountId) {
      const backupIdentifer = imyRecipient && imyRecipient.basicDetails && `${ imyRecipient.basicDetails.parentAccountId }-${ imyRecipient.guid || '' }`;
      selfAccount = imyRecipient && (imyRecipient.basicDetails.accountId === accountId || backupIdentifer === accountId) ? 'self' : null;
    }

    return parentAccount || selfAccount || null;
  };

  getToggleState = (rowIdentifier) => {
    const { statement, tierCollapseStructure, match: { params: { accountId: pAccountId } } } = this.props;
    if (statement && statement.intermediaryName && statement.intermediaryName === rowIdentifier) {
      const { toggleState } = this.state;
      return toggleState;
    }

    const storedState = tierCollapseStructure && tierCollapseStructure[pAccountId] && tierCollapseStructure[pAccountId][rowIdentifier];

    return storedState?.toggleState || {
      isTierExpanded: false,
      isOverrideTopTier: false,
      isAdditionalExpanded: false
    };
  };

  handleChangeImyParentInputChange = (event) => {
    const { changeParentData } = this.state;
    const name = event.target && event.target.name;
    const value = event.target && event.target.value;

    const newData = {
      ...changeParentData,
      [name]: value
    };

    this.setState({ changeParentData: newData });
  };

  updateToggledCollapsibleTiers = (rowIdentifier, toggleOptions) => {
    const { tierCollapseStructure, match: { params: { accountId: pAccountId } }, dispatch } = this.props;
    const { isAllTiersExpanded } = this.state;
    const updatedStucture = Object.assign({}, tierCollapseStructure) || { [pAccountId]: null };

    if (!updatedStucture[pAccountId]) {
      updatedStucture[pAccountId] = { allTiersExpanded: isAllTiersExpanded };
    } else {
      updatedStucture[pAccountId].allTiersExpanded = isAllTiersExpanded;
    }

    updatedStucture[pAccountId][rowIdentifier] = toggleOptions;

    dispatch(saveCollapsedTiers(updatedStucture));
  };

  updateTierSetExpanded = (rowIdentifier) => {
    const { tierCollapseStructure, match: { params: { accountId: pAccountId } }, dispatch } = this.props;
    const { isAllTiersExpanded } = this.state;
    const updatedStucture = Object.assign({}, tierCollapseStructure) || { [pAccountId]: null };

    if (!updatedStucture[pAccountId]) {
      updatedStucture[pAccountId] = { allTiersExpanded: isAllTiersExpanded };
    }

    const toggleState = updatedStucture[pAccountId][rowIdentifier] || { isAdditionalExpanded: false };
    toggleState.isTierExpanded = true;
    toggleState.isOverrideTopTier = true;
    updatedStucture[pAccountId][rowIdentifier] = toggleState;

    dispatch(saveCollapsedTiers(updatedStucture));
  };

  setCollapsibleTier = (rowIdentifier, isToggled) => {
    const { statement } = this.props;
    const toggleState = this.getToggleState(rowIdentifier);

    toggleState.isTierExpanded = isToggled;
    if (statement && statement.intermediaryName && statement.intermediaryName === rowIdentifier) {
      this.setState({ toggleState });
    }

    this.updateToggledCollapsibleTiers(rowIdentifier, toggleState);
  };

  toggleCollapseAllTiers = (isToggled) => {
    const { toggleState, isAllTiersExpanded } = (isToggled === true || isToggled === false) ? { isAllTiersExpanded: !isToggled } : this.state;
    const { statement } = this.props;
    toggleState.isTierExpanded = !isAllTiersExpanded;
    this.setState({ toggleState, isAllTiersExpanded: !isAllTiersExpanded });
    this.updateToggledCollapsibleTiers(statement.intermediaryName, toggleState);
  };

  toggleCollapseTier = () => {
    const { toggleState } = this.state;
    const { statement } = this.props;
    toggleState.isTierExpanded = !toggleState.isTierExpanded;
    this.setState({ toggleState });
    this.updateToggledCollapsibleTiers(statement.intermediaryName, toggleState);
  };

  expandTier = () => {
    const { toggleState } = this.state;
    const { statement } = this.props;

    toggleState.isTierExpanded = true;

    this.setState({ toggleState });
    this.updateToggledCollapsibleTiers(statement.intermediaryName, toggleState);
  };

  getOwnersOptionsList = () => {
    const { beneficiaryList } = this.props;

    if (!beneficiaryList) {
      return [];
    }

    return beneficiaryList.map((owner) => {
      const parent = (owner.parents && owner.parents.length > 0 && ` - (${ owner.parents[owner.parents.length - 1] })`) || '';
      return {
        display: `${ owner.name ?? owner.accountName }${ parent }`,
        key: owner.guid || owner.name || owner.accountName,
        value: WhdStatement.buildElementId(owner.guid || owner.name || owner.accountName),
        searchValue: owner.name ?? owner.accountName,
        parentTier: owner.parents && owner.parents.length > 0 && owner.parents[owner.parents.length - 1],
        parentIdentifier: owner.parentIdentifier,
        isIMY: owner.isIMY
      };
    });
  };

  onChangeParentCancel = () => {
    this.setState({ isChangeParentOpen: false });
  };

  onChangeParentSubmit = () => {
    const { dispatch, structure: { basicDetails: { accountId } } } = this.props;
    const { changeParentData, childAccountId, childOwnerGuid, childParentId, isOwnerParentChange, childParentGuid } = this.state;

    const newParentIdentifier = changeParentData?.newParentIdentifier?.split('|') ?? [null, null];
    const newParentAccountId = newParentIdentifier[0];
    const newParentGuid = newParentIdentifier[1];

    const changeParentDetails = {
      ...changeParentData,
      childAccountId,
      childOwnerGuid,
      currentParentAccountId: childParentId ?? 0,
      currentParentGuid: childParentGuid,
      newParentAccountId,
      newParentGuid
    };

    this.setState({ isChangeParentOpen: false });

    if (isOwnerParentChange) {
      dispatch(changeBoParent(accountId, changeParentDetails));
    } else {
      dispatch(changeImyTierParent(accountId, changeParentDetails));
    }
  };

  openChangeParentModal = (guid, item, index, isOwnerParentChange = false) => {
    const { isChangeParentOpen } = this.state;
    const { beneficiaryList } = this.props;

    if (!isChangeParentOpen) {
      this.setState({ isChangeParentOpen: true });
    }

    const owner = beneficiaryList?.find(x => x.guid === guid || x.name === item.name);

    this.setState({ childAccountId: item.accountId });
    this.setState({ childOwnerGuid: guid });
    this.setState({ childOwnerName: item.name });
    this.setState({ childParentId: item.parentAccountId });
    this.setState({ childParentGuid: owner?.parentIdentifier || null });
    this.setState({ isOwnerParentChange });

    const currentParent = this.getParent(item.parentAccountId);

    this.setState({ childParentName: (currentParent && currentParent.name) || null });
  };

  tierHasValidationErrors = () => {
    const { structure, validationResult } = this.props;
    if (!structure.recipients || !validationResult?.lines || validationResult.lines.length === 0) {
      return false;
    }

    return structure.recipients.some((recipient) => {
      const lineNo = recipient && (recipient.lineNo || (recipient.ownerDetails && recipient.ownerDetails.lineNo > 0 && recipient.ownerDetails.lineNo));
      const lineValidation = lineNo > 0 && validationResult.lines.find(result => result.lineNumber === lineNo);

      return lineValidation
        && (ValidationInspector.hasRejections(lineValidation)
          || ValidationInspector.hasWarnings(lineValidation));
    });
  };

  reAssignItem = () => {
    const { dispatch, changeOwnershipItem } = this.props;
    if (changeOwnershipItem != null && changeOwnershipItem.id != null) {
      dispatch(takeQueueItem('form', changeOwnershipItem.id, changeOwnershipItem.accountId));
      dispatch(hideOwnershipModal());
    }
  };

  openAccountWithholdingModal = (formId) => {
    const { dispatch } = this.props;
    dispatch(showAccountWithholdingModal(formId, null, null));
  };

  openPooledRatesModal = (guid, rates) => {
    const { dispatch } = this.props;
    dispatch(showPooledRatesModal(guid, rates));
  };

  togglePill = (pillName) => {
    this.setState(prevState => ({
      selectedPills: {
        ...prevState.selectedPills,
        [pillName]: !prevState.selectedPills[pillName],
      }
    }));
  };

  getPillClass = (count, pillName) => {
    const { selectedPills } = this.state;
    return `${ count === 0 ? 'grey' : '' } ${ selectedPills[pillName] ? 'selected' : '' }`;
  };

  extractAllRecipients() {
    const { structure } = this.props;
    const allRecipients = [];

    const flatten = (recipients) => {
      recipients.forEach((r) => {
        if (r.basicDetails) {
          allRecipients.push(r);
        }

        if (Array.isArray(r.recipients)) {
          flatten(r.recipients);
        }
      });
    };

    if (structure?.recipients) {
      flatten(structure.recipients);
    }

    return allRecipients;
  }

  calculateFilterCounts() {
    const { structure, validationResult } = this.props;
    if (!structure?.recipients) return;

    const all = this.extractAllRecipients(structure.recipients || []);

    let missingFormsCount = 0;
    let invalidFormsCount = 0;
    let inReviewFormsCount = 0;
    let missingAllocationCount = 0;
    let rejectionsCount = 0;
    let warningsCount = 0;

    all.forEach((r) => {
      const {
        isFormMissing,
        isFormInvalid,
        isFormInReviewStage,
        isBoMissingAllocation,
        warningCount: boWarningCount,
        rejectionCount: boRejectionCount
      } = BeneficialOwner.checkRecipientFilterMatches(r, validationResult);

      if (isFormMissing) {
        missingFormsCount += 1;
      }
      if (isFormInvalid) {
        invalidFormsCount += 1;
      }
      if (isFormInReviewStage) {
        inReviewFormsCount += 1;
      }
      if (isBoMissingAllocation) {
        missingAllocationCount += 1;
      }
      if (boWarningCount > 0) {
        warningsCount += 1;
      }
      if (boRejectionCount > 0) {
        rejectionsCount += 1;
      }
    });

    this.setState({
      missingFormsCount,
      invalidFormsCount,
      inReviewFormsCount,
      missingAllocationCount,
      rejectionsCount,
      warningsCount
    });
  }

  openAddFormModal(item) {
    const { dispatch } = this.props;
    dispatch(showAddFormModal(item, null));
  }

  addForms(parentForm, values, onlineForm) {
    const { dispatch } = this.props;
    dispatch(addForm(parentForm, values, onlineForm));
  }

  closeAddFormModal(item) {
    const { dispatch, match: { params: { accountId } } } = this.props;
    dispatch(hideAddFormModal(item));
    dispatch(getWhdStatement([accountId]));
  }

  closeFromOwnershipModal() {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal());
  }

  continueFromOwnershipModal() {
    const { dispatch, changeOwnershipItem } = this.props;
    dispatch(hideOwnershipModal());
    let redirectUrl = `/forms/${ changeOwnershipItem.formType.toLowerCase() }/${ changeOwnershipItem.id }`;
    if (changeOwnershipItem.accountId) {
      redirectUrl = `${ redirectUrl }?account=${ changeOwnershipItem.accountId }`;
    }
    history.push(redirectUrl);
  }

  addBeneficialOwner(accountId, parentGuid, isImyLayer, isPooled, preventExpand, ownerId) {
    const { dispatch } = this.props;
    const rowIdentifier = ownerId || parentGuid;
    if (!preventExpand && rowIdentifier) {
      this.updateTierSetExpanded(rowIdentifier);
    }
    dispatch(addNewBeneficialOwner(accountId, parentGuid, isImyLayer, isPooled, rowIdentifier));
    setTimeout(() => {
      dispatch(setStatementPosition(accountId, window.pageYOffset));
    }, 1000);
  }

  isJointAccount() {
    const { statement } = this.props;
    return statement?.jointAccountElection?.toLowerCase() === 'yes';
  }

  render() {
    const {
      isGettingStatement,
      isUpdatingStatement,
      isStructureValid,
      permissions,
      settings,
      statement,
      structure,
      validationResult,
      match: { params: { accountId: pAccountId, versionNumber } },
      isOwnershipModalShown,
      changeOwnershipItem,
      isAccountWithholdingShown,
      isAddFormModalShown,
      isSavingStatement,
      tierCollapseStructure,
      isPooledRatesModalShown,
      isDeletingRow,
      isAddingNewBeneficalOwner,
      dispatch,
      topAccount,
      versionWindows
    } = this.props;

    const { toggleState: { isTierExpanded }, activeTab, isAllTiersExpanded, isChangeParentOpen, childAccountId, childOwnerName, childOwnerGuid, childParentId, childParentName,
      missingFormsCount, invalidFormsCount, inReviewFormsCount, missingAllocationCount, rejectionsCount, warningsCount, selectedPills, isOwnerParentChange } = this.state;

    const hasPermission = AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrEditWhs, ActivityPerms.multiTierMgrViewWhs]);
    const canEditPermission = AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrEditWhs]);
    const canUploadPermission = AccessControl.hasPermission(permissions, [ActivityPerms.scannedUpload, ActivityPerms.scannedWhdStmtBoUpload], true);
    const isMTMLicensed = settings.showMultiTierManager;
    const isBulkImyLicensed = settings.showBulkImyUpload;
    const isPooled = statement && statement.type === StatementTypes.PooledWhdStatement;
    const accountId = parseInt(pAccountId, 10) || null;
    const showingVersion = (versionNumber !== null && typeof versionNumber !== 'undefined') || statement?.isPublishedFallback === true;
    const imyLayerOptions = isChangeParentOpen && this.getStatementImyLayers(childAccountId || `${ childParentId }-${ childOwnerGuid }`, childParentId)
      .map(x => (
        <option
          className={ x.relation ? 'disabled italic' : '' }
          disabled={ !!x.relation }
          key={ `${ x.accountId }|${ x.guid }` }
          value={ `${ x.accountId || '' }|${ x.guid || '' }` }
        >{ x.level > 0 && [...Array(x.level - 1), '-\u00A0\u00A0\u00A0'].map((e, i) => e || '\u00A0\u00A0\u00A0') }{ x.name }{ x.relation && `\u00A0\u00A0\u00A0(${ x.relation })` }</option>
      ));

    const withholdingStruct = structure;
    const tierRecipients = this.getTierRecipientCount();
    const tierIntermediaries = this.getTierIntermediaryCount();
    const collapseStructure = tierCollapseStructure ? Object.assign({}, tierCollapseStructure[pAccountId]) : null;

    const buildImyTierObject = (item) => {
      if (!item) {
        return null;
      }
      const formObject = {
        accountId: item.accountId,
        accountName: item.name,
        accountNumber: item.accountNumber,
        customerDbId: item.customerDbId,
        customerId: item.customerIdentifier,
        customerName: item.customerName,
      };

      return formObject;
    };

    const ownerList = this.getOwnersOptionsList();

    const scrollToItem = (item) => {
      const id = WhdStatement.buildElementId(item.value);
      if (item.parentIdentifier && item.parentIdentifier !== statement.intermediaryName && !item.isIMY) {
        this.updateTierSetExpanded(item.parentIdentifier);
      } else if (item.parentIdentifier && item.parentIdentifier === statement.intermediaryName && !item.isIMY) {
        this.expandTier();
      }

      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          setTimeout(() => {
            dispatch(setStatementPosition(accountId, window.pageYOffset));
          }, 1000);
        }
      }, 100);
    };

    const versionExpired = statement && statement.effectiveTo && moment(statement.effectiveTo).isBefore(moment(), 'day');
    const versionExpiring = statement && statement.effectiveTo && moment(statement.effectiveTo).isSame(moment(), 'day');
    const versionCurrent = statement && statement.effectiveTo && moment(statement.effectiveTo).isAfter(moment(), 'day');
    const versionOpenEnded = statement && (!statement.effectiveTo || statement.effectiveTo.length === 0);

    const missingForm = structure?.basicDetails?.formId === null;
    const invalidForm = !missingForm && (structure?.basicDetails?.formIsValid === false || structure?.basicDetails?.formIsValid == null);
    const formInReview = structure?.basicDetails?.workflowStage >= 4 && structure?.basicDetails?.workflowStage <= 9;
    const formComplete = structure?.basicDetails?.workflowStage === 100;
    const hasRejections = validationResult?.rejections?.length > 0;
    const hasWarnings = validationResult?.warnings?.length > 0;

    const tabs = [
      {
        title: 'Structure',
        index: 0,
        id: 'tab-structure',
      },
      {
        title: 'Forms',
        index: 1,
        id: 'tab-forms',
        disabled: showingVersion,
      },
      {
        title: 'Uploads',
        index: 2,
        id: 'tab-uploads',
        disabled: showingVersion,
      },
    ];

    const showTabs = isBulkImyLicensed;

    const selectTab = (newIndex) => {
      const tab = tabs.find(t => t.index === newIndex);
      if (tab && tab.disabled) {
        return;
      }
      if (newIndex !== activeTab) {
        this.setState({ activeTab: newIndex });
      }
    };

    return (
      <div className="digital-whd-statement" key="imy" style={ { height: '100%' } } onScroll={ e => this.scroll(e) }>
        { (!isMTMLicensed || !hasPermission) && <div className="access-error">
          { !isMTMLicensed && <h2>Your licence does not grant access to Multi-Tier Management</h2> }
          { isMTMLicensed && !hasPermission && <h2>You do not have permission to access the Digital Withholding Statement</h2> }
          <p>Please contact your administrator for more details</p>
        </div> }
        { isMTMLicensed && hasPermission && <React.Fragment>
          <h1>Digital Withholding Statement</h1>
          {showingVersion && versionExpiring && <Banner
            mainText="Withholding Statement: Published (expires today)"
            subText="Withholding Rates as of the Effective To date"
            className="toast-red"
          />}
          {showingVersion && versionExpired && <Banner
            mainText={ `Withholding Statement: Expired (${ statement && statement.effectiveTo })` }
            subText="Withholding Rates as of the Effective To date"
            className="toast-red"
          />}
          {showingVersion && versionCurrent && <Banner
            mainText={ `Withholding Statement: Published (expires ${ statement && statement.effectiveTo })` }
            className="toast-blue"
          />}
          {showingVersion && versionOpenEnded && <Banner
            mainText="Withholding Statement: Published (no expiry)"
            className="toast-blue"
          />}
          {!showingVersion && <Banner
            mainText="Withholding Statement: Draft"
            className="toast-grey"
          />}
          { isGettingStatement && <LoadingWrapper loaded={ !isGettingStatement } message="Please wait while Multi-Tier Manager fetches the Withholding Statement" /> }
          { !isGettingStatement && !statement && <NotFoundPage caption="Withholding Statement Not Found" /> }
          { statement && <div>
            <div className="columns">
              <div className="col-8 mb-2">
                <IntermediaryDetailsPanel
                  accountId={ pAccountId }
                  getChapter3DescriptionByName={ WhdStatement.getImyChapter3DescriptionByName }
                  getChapter4DescriptionByName={ WhdStatement.getChapter4DescriptionByName }
                  statement={ statement }
                  dispatch={ dispatch }
                  permissions={ permissions }
                  validationResult={ validationResult || null }
                  showingVersion={ showingVersion }
                />
              </div>
              <div className="col-4 mb-2">
                <StatementOptionsPanel
                  accountId={ pAccountId }
                  statement={ statement }
                  structure={ structure }
                  dispatch={ dispatch }
                  permissions={ permissions }
                  validationResult={ validationResult || null }
                  showingVersion={ showingVersion }
                />
              </div>
              <div className="col-12 my-2">
                <StatementActionsPanel
                  accountId={ accountId }
                  statement={ statement }
                  structure={ structure }
                  validationResult={ validationResult }
                  expandTier={ tierName => this.setCollapsibleTier(tierName, true) }
                  className="whs-top-level"
                  statementVersion={ versionNumber }
                  versionWindows={ versionWindows }
                  isExportImyLicensed={ settings.showExportImy }
                />
              </div>
              { showTabs && <ul className="tab col-12">
                { tabs != null && tabs.map(tab => (
                  <li
                    key={ tab.index }
                    className={ `tab-item ${ tab.index === activeTab ? 'active' : '' } ${ tab.disabled ? 'disabled' : '' }` }
                  >
                    <button
                      type="button"
                      id={ tab.id }
                      tabIndex={ tab.index }
                      disabled={ tab.disabled }
                      onClick={ () => selectTab(tab.index) }
                    >{ tab.title }</button>
                  </li>
                )) }
              </ul> }
              { (!showTabs || activeTab === 0) && <StatementStructureTab
                buildElementId={ WhdStatement.buildElementId }
                getChapter3DescriptionByName={ WhdStatement.getChapter3DescriptionByName }
                getChapter4DescriptionByName={ WhdStatement.getChapter4DescriptionByName }
                getIsDirectBeneficialOwner={ WhdStatement.getIsDirectBeneficialOwner }
                statement={ statement }
                structure={ structure }
                settings={ settings }
                permissions={ permissions }
                accountId={ accountId }
                versionNumber={ versionNumber }
                isTierExpanded={ isTierExpanded }
                isAllTiersExpanded={ isAllTiersExpanded }
                isPooled={ isPooled }
                showingVersion={ showingVersion }
                isSavingStatement={ isSavingStatement }
                isDeletingRow={ isDeletingRow }
                isStructureValid={ isStructureValid }
                isAddingNewBeneficalOwner={ isAddingNewBeneficalOwner }
                canUploadPermission={ canUploadPermission }
                canEditPermission={ canEditPermission }
                tierRecipients={ tierRecipients }
                tierIntermediaries={ tierIntermediaries }
                selectedPills={ selectedPills }
                validationResult={ validationResult }
                collapseStructure={ collapseStructure }
                toggleCollapseTier={ this.toggleCollapseTier }
                tierHasValidationErrors={ this.tierHasValidationErrors }
                openAddFormModal={ node => this.openAddFormModal(node) }
                addBeneficialOwner={ (id, parentGuid, isImyLayer, isPool, preventExpand, ownerId) => this.addBeneficialOwner(id, parentGuid, isImyLayer, isPool, preventExpand, ownerId) }
                isJointAccount={ () => this.isJointAccount() }
                openChangeParentModal={ this.openChangeParentModal }
                openAccountWithholdingModal={ formId => this.openAccountWithholdingModal(formId) }
                updateToggledCollapsibleTiers={ (rowIdentifier, toggleState) => this.updateToggledCollapsibleTiers(rowIdentifier, toggleState) }
                openPooledRatesModal={ (guid, rates) => this.openPooledRatesModal(guid, rates) }
                buildImyTierObject={ buildImyTierObject }
                dispatch={ dispatch }
                withholdingStruct={ withholdingStruct }
                missingForm={ missingForm }
                formInReview={ formInReview }
                formComplete={ formComplete }
                invalidForm={ invalidForm }
                hasRejections={ hasRejections }
                hasWarnings={ hasWarnings }
                ownerList={ ownerList }
                scrollToItem={ scrollToItem }
                togglePill={ pill => this.togglePill(pill) }
                getPillClass={ (count, pillName) => this.getPillClass(count, pillName) }
                missingFormsCount={ missingFormsCount }
                invalidFormsCount={ invalidFormsCount }
                inReviewFormsCount={ inReviewFormsCount }
                missingAllocationCount={ missingAllocationCount }
                rejectionsCount={ rejectionsCount }
                warningsCount={ warningsCount }
                toggleCollapseAllTiers={ this.toggleCollapseAllTiers }
              /> }
              { showTabs && activeTab === 1 && !showingVersion && <StatementFormsTab
                accountId={ accountId }
              /> }
              { showTabs && activeTab === 2 && !showingVersion && <StatementUploadsTab
                accountId={ accountId }
              /> }
            </div>
            <ModalWrapper title="Saving changes..." headerClose={ false } showFooter={ false } isOpen={ isUpdatingStatement }>
              <div className="whd-statement-modal-saving-body"><LoadingWrapper loaded={ !isUpdatingStatement } message="Please wait while the changes are saved" /></div>
            </ModalWrapper>
          </div> }
          <ModalWrapper
            title={ `Change Parent${ isOwnerParentChange ? ' (Owner)' : ' (Tier)' }` }
            className="change-parent-modal"
            isOpen={ isChangeParentOpen }
            onCancel={ this.onChangeParentCancel }
            onConfirm={ this.onChangeParentSubmit }
            shouldCloseOnOverlayClick
          >
            <p>Change Parent for <strong>{ childOwnerName }</strong> ({ childAccountId })</p>
            <p className="mt-2">Current Parent: { childParentName } ({ childParentId })</p>
            <div className="form-group">
              <select name="newParentIdentifier" className="form-select" defaultValue="" onChange={ this.handleChangeImyParentInputChange }>
                <option value="" disabled>Select new parent</option>
                { imyLayerOptions }
              </select>
            </div>
          </ModalWrapper>
        </React.Fragment> }
        { changeOwnershipItem != null && <ChangeOwnershipModal
          isShown={ isOwnershipModalShown }
          onAssign={ () => this.reAssignItem() }
          onContinueWithoutAssign={ () => this.continueFromOwnershipModal() }
          onCancel={ () => this.closeFromOwnershipModal() }
          workflowRecord={ changeOwnershipItem }
        /> }
        <WithholdingRatesModal
          isShown={ isAccountWithholdingShown }
          onClose={ () => this.onCloseWithholdingModal() }
        />
        {!settings.selectedClient.isPiiProtectionEnabled && <AddFormModal
          isShown={ isAddFormModalShown }
          onConfirmUpload={ (imyTier, values) => this.addForms(imyTier, values, false) }
          onCancel={ () => this.closeAddFormModal() }
        />}
        { isPooled && <PooledRatesModal
          structureId={ structure?.basicDetails?.formId }
          accountId={ accountId }
          isShown={ isPooledRatesModalShown }
          statementVersion={ versionNumber }
          onClose={ () => this.onClosePooledRatesModal() }
          permissions={ permissions }
        /> }
        { accountId > 0 && topAccount && topAccount.isWhsLinkingActive
          && <LinkWhsAccountModal
            key="LinkWhsAccount"
            isShown={ topAccount.isWhsLinkingActive }
            accountId={ accountId }
            reloadOnComplete={ false }
          />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions,
      settings
    },
    withholdingStatement: {
      beneficiaryList,
      isGettingStatement,
      isSavingStatement,
      isUpdatingStatement,
      statement,
      structure,
      statementPosition,
      tierCollapseStructure,
      validationResult,
      isDeletingRow,
      isStructureValid,
      isAddingNewBeneficalOwner,
      topAccount,
      versionWindows
    },
    forms: {
      isAccountWithholdingShown,
      isAddFormModalShown,
      isPooledRatesModalShown
    },
    workflow: {
      isOwnershipModalShown,
      changeOwnershipItem
    }
  } = state;

  return {
    isGettingStatement,
    beneficiaryList,
    isSavingStatement,
    isUpdatingStatement,
    permissions,
    settings,
    statement,
    structure,
    statementPosition,
    isOwnershipModalShown,
    changeOwnershipItem,
    isAccountWithholdingShown,
    isAddFormModalShown,
    validationResult,
    tierCollapseStructure,
    isPooledRatesModalShown,
    isDeletingRow,
    isStructureValid,
    isAddingNewBeneficalOwner,
    topAccount,
    versionWindows
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(WhdStatement, 'WhdStatement')));
